import { z } from "zod";
import { CustomFieldTypeSchema } from "./custom-field.schemas.js";
export const customFieldValueSchema = z.object({
  value: z.union([z.string(), z.number(), z.boolean(), z.null()]),
  type: CustomFieldTypeSchema,
});

export type CustomFieldValue = z.infer<typeof customFieldValueSchema>;
